import { render, staticRenderFns } from "./workRecordDialog.vue?vue&type=template&id=1ec66560&scoped=true&"
import script from "./workRecordDialog.vue?vue&type=script&lang=js&"
export * from "./workRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec66560",
  null
  
)

export default component.exports